import { View, ViewType } from "@common/types/views/views";

export enum HistoryRuleGroupDetailsColumn {
    TIME = "time",
    GROUP_NAME = "groupName",
    PREVIOUS = "previous",
    MODIFIED = "modified",
}

export interface HistoryRuleGroupDetailsView extends View {
    type: ViewType.HISTORY_UPDATED_TRANSACTION;
    columns: Array<{ id: HistoryRuleGroupDetailsColumn; options?: any }>;
}
